export const routes = [
  ...require('./samae/routes').routes
]
